import globals from 'globals';
import $ from 'jquery';
import ko from 'knockout';
import ProductViewModel from 'product-view-model';
import ProductChoiceSelectorViewModel from 'product-choice-selector-view-model';
import ProductSampleCart from 'product-sample-cart';
import VisualizerViewModel from 'visualizer-view-model';
import 'pricing-support';
import 'dictionary';
import 'slick';
import 'sticky-kit';
import 'binding-handlers';
import 'visibility';
import 'scroll-to';
import 'tappy';
import 'visualizerImage';
import 'color-swatch-preview';
import 'picturefill';

$(function () {

  var productViewModel = new ProductViewModel();
  productViewModel.init();

  if (![1, 2].includes(pageContextJavascript.siteId)) {
    var visualizerViewModel = new VisualizerViewModel(globals.productId, globals.visualizedOptions);
    ko.applyBindings(visualizerViewModel, $('.bdc-visualizer')[0]);
  }

  var selector = new ProductChoiceSelectorViewModel(globals.productId, productViewModel);
  selector.init();

  var cart = new ProductSampleCart();
  cart.init();

  productViewModel.loadReviews();

  const stickOffset = globals.stickOffset || {
    tablet: 135,
    desktop: 30
  };

  // American Blinds
  if (pageContextJavascript.siteId === 1) {
    import(/* webpackChunkName: 'ab_pip' */ '../../../../javascript/ab/pages/pip');
  }

  const initializeProductPreviewMicroApp = () => {
    if (typeof window !== 'undefined') {
    $.when(
        $.get('/ordering/cart/getsamplecart'),
        $.ajax({url: `/api/promotions/${globals.siteId}/${globals.productId}`})
    )
    .then(function(samplesResponse, promoResponse) {

      const promotionalData = promoResponse.filter(item => item.stackablePercentOff ? item.stackablePercentOff : 0);

      const samplesData = samplesResponse.filter(item => item.Data);
      const { OriginalPrice, Percentage, PromoSnippet } = globals.models.strikethroughPrice;
      const price =  {
        originalPrice: OriginalPrice,
        percentOff: Percentage,
        promoDescription: PromoSnippet,
        stackablePercentage: promotionalData.map((promo) => promo.stackablePercentOff ? promo.stackablePercentOff : 0),
      };

      const localVisModel = JSON.parse(localStorage.getItem('product-preview'));
      const detail = {
        ...localVisModel,
        price,
        siteId: globals.siteId,
        productId: globals.productId,
        variantId: globals.variantId,
        samplesInCart: samplesData[0].Data.map((sample) => sample.ChoiceId).length,
        isMandi: globals.isMandi ? true : false,
      };

      localStorage.setItem('product-preview', JSON.stringify(detail));

      const productPreview = document.getElementById('product-preview-ma-container');
      if (productPreview) {
        import(/* webpackChunkName: "productPreview" */ '../../../../javascript/_shared/micro-apps/product-preview').then(
          ({ default: ProductPreview }) => {
            ReactDOM.render(<ProductPreview />, productPreview);
          }
        );
      }
    })
    .fail(function(err) {
        console.log('Something went wrong', err);
    });
    }
  }

  if ([1, 2].includes(pageContextJavascript.siteId)) {
    initializeProductPreviewMicroApp();
  }
});
